import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/Core/interceptors/http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeographyService {
  constructor(private http: HttpService) {}

  countries() {
    return this.http.get(
      `${environment.url}/main-website-general/countries`
    );
  }
  statesCities(countryId: any) {
    return this.http.get(
      `${environment.url}/main-website-general/statesCities?country_id=${countryId}`
    );
  }
}
